export const formDefaultValue = {
  entity: {
    name: '',
    izin_usaha: {
      type: '',
      number: ''
    },
    type: {
      type: '',
      description: ''
    },
    first_akta_pendirian_number: '',
    address: {
      street_address: '',
      rt: '',
      rw: '',
      province: '',
      city: '',
      district: '',
      village: '',
      postal_code: '',
      country: 'ID',
      dati2: ''
    },
    phone_number: '',
    phone_ext: '',
    fax: '',
    mobile_number: '',
    account_purpose: {
      purpose: '',
      description: ''
    },
    document_ids: {
      npwp: '',
      ad_arts: [],
      nib: '',
      siup: '',
      tdp: '',
      skdp: '',
      situ: '',
      sk_menkumham: '',
      laporan_keuangan: '',
      bukti_pendaftaran_perkumpulan: '',
      persetujuan_bendahara_umum_negara: '',
      other_supporting_documents: [],
      ditjen_ahu: []
    },
    estimated_credit_amount: '',
    estimated_debit_amount: '',
    estimated_credit_frequency: '',
    estimated_debit_frequency: '',
    primary_income_source: {
      type: '',
      description: ''
    },
    business_type: '',
    nationality: 'ID',
    number_of_employees: '',
    entity_assets: '',
    managements: [
      {
        name: '',
        position: '',
        email_address: '',
        phone_number: '',
        identity_document_id: '',
        address: '',
        gender: '',
        identity_number: ''
      }
    ],
    beneficial_owner: {
      name: '',
      phone_number: '',
      gender: '',
      marital_status: '',
      address: {
        street_address: '',
        rt: '',
        rw: '',
        province: '',
        city: '',
        district: '',
        village: '',
        postal_code: ''
      },
      domicile_address: {
        street_address: '',
        rt: '',
        rw: '',
        province: '',
        city: '',
        district: '',
        village: '',
        postal_code: ''
      },
      identity_document_id: '',
      citizenship: 'ID',
      npwp: '',
      profession: '',
      income_source: '',
      monthly_income: '',
      document_ids: [],
      relationship: ''
    },
    npwp: '',
    monthly_income: ''
  },
  surat_kuasa: {
    management_authoriser_identity_numbers: [],
    authorised_signatories: [
      {
        identity_number: '',
        date_of_birth: '',
        place_of_birth: '',
        name: '',
        mobile_number: '',
        email_address: '',
        identity_document_id: '',
        gender: '',
        marital_status: '',
        profession: '',
        relationship: '',
        powers: ['SUBMIT_APPLICATION']
      }
    ],
    terms: ''
  },
  submissionId: ''
};
